<template>
  <div id="blockZhangfu"
       :class="{'detail-zhangfu':showDetailChart}"
       class="blockZhangfu">
    <card-title cardtitle='板块表现'
                class="card-title"></card-title>
    <!-- <div v-if="!myclientType"> -->
    <!-- <card-switch class="card-switch" :sWitch.sync="sWitch" selectarr='["涨幅","资金"]' v-show="myclientType"></card-switch> -->
    <!-- <day-switch class="day-switch" :daynu/mber.sync="daynumber" v-if="!sWitch"></day-switch> -->
    <!-- <div id="risebar-wrap"
           v-if="timeType != 'waitTime'"
           class="risebar-wrap">
        <chart-risebar ref="risebar"
                       :theme="theme"
                       :data="data"
                       :xAxis="xAxis"
                       id="chart-risebar">
        </chart-risebar>
      </div>
      <div v-else
           class="nodata">
        <div class="notTime">还未开盘，稍等片刻</div>
      </div>
    </div>
    <div v-else> -->
    <card-switch class="card-switch"
                 :sWitch.sync="sWitch"
                 :selectarr='selectarr'></card-switch>
    <day-switch class="day-switch"
                :daynumber.sync="daynumber"></day-switch>
    <div id="risebar-wrap"
         v-if="timeType != 'waitTime'"
         class="risebar-wrap">
      <keep-alive>
        <!-- <chart-risebar ref="risebar"
                       :theme="theme"
                       :data="data"
                       :xAxis="xAxis"
                       v-if="sWitch==1"
                       id="chart-risebar">
        </chart-risebar> -->
        <zhangfu v-if="sWitch==1"
                 :sWitch="sWitch"
                 ref="risebar"
                 :hoverZhangfu="hoverZhangfu"
                 :tradedays="daynumber"></zhangfu>
        <captical v-else
                  :sWitch="sWitch"
                  :hoverZhangfu="hoverZhangfu"
                  :tradedays="daynumber"></captical>
      </keep-alive>
      <span class="read-detail-icon"
            v-show="hoverZhangfu&&!showDetailChart"
            @click="openDetail"></span>
    </div>
    <div v-else
         class="nodata">
      <div class="notTime">还未开盘，稍等片刻</div>
    </div>
  </div>
  <!-- 板块涨幅 -->
  <!-- </div> -->

</template>
<script>
import cardTitle from '@/components/card/cardTitle.vue';
// import { component as risebar } from '@/lib/risebar/risebar';

import cardSwitch from '@/components/card/cardSwitch.vue';
import captical from '@/components/G2/captical.vue';
import zhangfu from '@/components/G2/zhangfu.vue';
import daySwitch from '@/components/card/daySwitch.vue';
import { setInterval, clearInterval, setTimeout } from 'timers';

export default {
  name: 'blockZhangfu',
  components: {
    'card-title': cardTitle,
    zhangfu: zhangfu,
    'card-switch': cardSwitch,
    captical: captical,
    'day-switch': daySwitch
  },
  props: {
    showDetailChart: false
  },
  // created() {
  //   eventBus.$on("timeType", this.handle);
  //   let self = this;
  //   eventBus.$on("toggleSelectItem", function() {
  //     self.update();
  //   });
  // },
  mounted() {
    var self = this;
    self.theme = window.theme;
    // console.log($('#chart-risebar'))
    // if (self.timeType == 'tradingTime') {
    //   self.update();
    // } else if (self.timeType == 'waitTime') {
    //   self.update();
    // } else if (self.timeType == 'notTradingDay') {
    //   self.update();
    // }
    $(window).resize(function() {
      self.hoverZf();
    });
    this.hoverZf();
    // self.checkScreen();

    $('#risebar-wrap').on('mouseover', function() {
      // clearInterval(self.maidianInterval);
      // self.maidianInterval = setInterval(function() {
      //   TA.log({ id: 'L2rdzz_5a77fa85_108' });
      // }, 2000);
      clearTimeout(self.maidianInterval)
      self.maidianInterval = setTimeout(() => {
        TA.log({ id: 'L2rdzz_5a77fa85_108' });
      },100)
    });
    $('#risebar-wrap').on('mouseout', function() {
      // clearInterval(self.maidianInterval);
      clearTimeout(self.maidianInterval)
    });
  },
  activated() {
    this.update();
    // this.hoverZf();
    this.interval = window.$util.userInterval(this.update, 30000);
    eventBus.$on('timeType', this.handle);
    eventBus.$on('toggleSelectItem', this.update);
  },
  deactivated() {
    eventBus.$off('timeType', this.handle);
    eventBus.$off('toggleSelectItem', this.update);
    clearInterval(this.interval);
    clearInterval(this.maidianInterval);
  },
  // beforeDestroy() {
  //   eventBus.$off("timeType", this.handle);
  //   clearInterval(this.interval);
  //   clearInterval(this.maidianInterval);
  // },
  computed: {
    myclientType: function() {
      if (window.clientType === 2) {
        return true;
      } else {
        return false; // 这里到后面可以进行设置权限为false
      }
    }
  },
  data() {
    return {
      data: [],
      xAxis: [],
      theme: 'black',
      url: `//apigate.${window.Acme.getDomain()}/d/charge`,
      interval: null,
      selectarr: '["涨幅","资金"]',
      // waitTime:false,//交易日9点至9点25分
      maidianInterval: null,
      timeType: 'tradingTime', //tradingTime, notTradingDay, waitTime
      clientType: window.clientType,
      sWitch: 1,
      daynumber: 2,
      hoverZhangfu: false
    };
  },
  methods: {
    // checkScreen() {
    //   const self = this;
    //   // console.log(document.body.clientWidth);
    //   if (document.body.clientWidth <= 1366) {
    //     self.selectarr = '["涨幅","流入资金","流出资金"]';
    //     $('#captical-chart,#captical-out').css('width', '100%');
    //   } else {
    //     self.selectarr = '["涨幅","资金"]';
    //     $('#captical-chart,#captical-out').css('width', '48%');
    //   }
    // },
    hoverZf() {
      if (document.getElementById('blockZhangfu')) {
        if (window.innerWidth <= 1600) {
          this.hoverZhangfu = true;
        } else {
          this.hoverZhangfu = false;
        }
      }
    },
    handle(val) {
      this.timeType = val;
    },
    update: function() {
      const self = this;
      $.ajax({
        url: this.url + '/hottrack/api/getPlatePeriod',
        xhrFields: {
          withCredentials: true
        },
        success: function(data) {
          let response = { data: data };
          var xdata = [];
          if (response.data.errorcode === 0) {
            self.data = response.data.result.y;
            for (var i = 0; i < response.data.result.x.length; i++) {
              xdata.push(response.data.result.x[i] + '%');
            }
            // self.xAxis = response.data.result.x;
            self.xAxis = xdata;
          }
        }
      });
    },
    openDetail() {
      this.$eventBus.$emit('openWindow', 'blockZhangfu');
    }
  },
  watch: {
    sWitch: function(val) {
      const self = this;
      // 当switch为2的时候，应该将日期选择为今日
      // console.log(val, 'sss');
      if (val == 2) {
        this.daynumber = 1;
      } else if (val == 1) {
        this.daynumber = 2;
      }
    },
    daynumber: function(val) {
      // console.log(val)
      this.daynumber = val;
    }
  }
};
</script>
<style scoped>
.risebar-wrap {
  width: 100%;
  height: 196px;
}
.nodata {
  width: 100%;
  height: 196px;
}
.notTime {
  border: 1px solid #393939;
  width: 95%;
  height: 192px;
  margin: 0 auto;
  text-align: center;
  color: #ababab;
  font-size: 12px;
  line-height: 170px;
}
.blockZhangfu {
  position: relative;
  background-color: #1b1b1b;
  transition: 1s ease;
}
.white .notTime {
  border: 1px solid #ababab;
}
.white .blockZhangfu {
  background-color: #fff;
}
.detail-zhangfu {
  width: 900px;
}
.card-switch {
  /* display: inline-block; */
  position: absolute;
  left: 80px;
  top: 8px;
}

.day-switch {
  position: absolute;
  right: 40px;
  top: 8px;
}
.hover-zhangfu {
  position: absolute;
  width: 600px;
  z-index: 99;
  left: 223px;
}

.read-detail-icon {
  background: url(//i.thsi.cn/images/level2/hottrack/20190410/sprite.png) no-repeat;
  background-position: -55px 0;
  width: 13px;
  height: 14px;
  position: absolute;
  top: 10px;
  right: 18px;
  display: block;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/blockZhangfu.vue